import React, {Component} from 'react';
import '../react-router-modal/react-router-modal.css';
import '../css/components/alert.css';
import {
    formatCurrencyValue,
    getPricePerDayFromMonthlyRate, getPricePerDayFromWeeklyRate,
    parseCurrencyValue,
    validateCurrencyValue
} from "../util/PaymentUtils";
import Error from "./Error";
import { hasAdminAccess } from "../util/AccountUtils";
import { Account } from "../types/Account";
import { LocationEquipmentType } from "./EquipmentTypes";

interface EquipmentTypeOption {
    label: string;
    value: boolean;
    id?: string | null;
}

interface LocationEquipmentLocation {
    pricePerDay?: number | null;
    pricePerWeek?: number | null;
    pricePerMonth?: number | null;
}

interface LocationEquipmentProps {
    account?: Account | null;
    currentEquipment?: LocationEquipmentType | null;
    equipmentTypes?: Record<string, EquipmentTypeOption> | null;
    errorMessage?: string | null;
    currentEquipmentChanged: (equipment: LocationEquipmentType) => void;
    location?: LocationEquipmentLocation | null;
}

interface LocationEquipmentState {
    currentEquipment?: LocationEquipmentType | null;
    equipmentTypes?: Record<string, EquipmentTypeOption> | null;
    errorMessage?: string | null;
}

class LocationEquipment extends Component<LocationEquipmentProps, LocationEquipmentState> {
    constructor(props: LocationEquipmentProps) {
        super(props);
        this.state = {
            currentEquipment: this.props.currentEquipment ? this.props.currentEquipment : null,
            equipmentTypes: this.props.equipmentTypes ? this.props.equipmentTypes : null,
            errorMessage: this.props.errorMessage ? this.props.errorMessage : null,
        }
    }

    UNSAFE_componentWillMount() {
        this.setState({
            currentEquipment: this.props.currentEquipment ? this.props.currentEquipment : null,
            equipmentTypes: this.props.equipmentTypes ? this.props.equipmentTypes : null,
            errorMessage: this.props.errorMessage ? this.props.errorMessage : null
        })
    }

    UNSAFE_componentWillReceiveProps(newProps: LocationEquipmentProps) {
        if (newProps.currentEquipment) {
            this.setState({currentEquipment: newProps.currentEquipment});
        }
        if (newProps.equipmentTypes) {
            this.setState({equipmentTypes: newProps.equipmentTypes});
        }
        if (typeof newProps.errorMessage !== 'undefined') {
            this.setState({errorMessage: newProps.errorMessage});
        }
    }


    handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>): void => {
        const name = event.target.name;
        const target = event.target as HTMLInputElement;

        let value: string | number | boolean = (target.type === 'checkbox') ? target.checked : target.value;
        if (target.type === 'radio') {
            value = value !== "0";
        }
        if ('pricePerDay' === name || 'pricePerWeek' === name || 'pricePerMonth' === name) {
            if (!validateCurrencyValue(value as string)) {
                return;
            }
            value = parseCurrencyValue(value as string);
        }
        if (!this.state.currentEquipment) {
            return;
        }
        // Build a new object instead of mutating state.currentEquipment directly (previous
        // implementation mutated the existing object in place before calling setState).
        const newEq: LocationEquipmentType = {...this.state.currentEquipment, [name]: value};

        this.setState({currentEquipment: newEq});
        this.props.currentEquipmentChanged(newEq);
    };

    render() {
        const currentEquipment = this.state.currentEquipment;
        return (
            <div>
                <p className="up-margin">Select which equipment type and add pricing</p>
                {this.state.equipmentTypes && currentEquipment ?
                    <form className="form-horizontal">
                        <div className="form-group">
                            <label style={{marginBottom: "5px"}} className="col-sm-12">Equipment Type</label>
                            <div className="col-sm-12">

                                <select name="equipmentType" className="form-control"
                                        onChange={this.handleChange}
                                >
                                    {Object.keys(this.state.equipmentTypes).map((key) =>
                                        !this.state.equipmentTypes![key].value ?
                                            <option value={this.state.equipmentTypes![key].label} key={key}>
                                                {this.state.equipmentTypes![key].label}
                                            </option>
                                            :
                                            (this.state.equipmentTypes![key].label === currentEquipment.equipmentType ?
                                                    <option value={this.state.equipmentTypes![key].label} key={key}
                                                            selected>
                                                        {this.state.equipmentTypes![key].label}
                                                    </option>
                                                    :
                                                    ''
                                            )
                                    )}
                                </select>
                            </div>
                        </div>
                        <div className="form-group">
                            <label className="col-sm-12">Price</label>
                           <div className="row flex-wrap">
                           <div className="col-sm-6">
                                <label className="ss-checkbox">
                                    <input type="radio"
                                           className="ss-book-space-radio-input"
                                           name="customPrice"
                                           checked={!currentEquipment.customPrice}
                                           value="0"
                                           onChange={this.handleChange}
                                    />Use default pricing
                                </label>
                            </div>
                            <div className="col-sm-6">
                                <label className="ss-checkbox">
                                    <input type="radio"
                                           className="ss-book-space-radio-input"
                                           name="customPrice"
                                           checked={!!currentEquipment.customPrice}
                                           value="1"
                                           onChange={this.handleChange}
                                    />Use custom pricing
                                </label>
                            </div>
                           </div>
                        </div>

                        {
                            currentEquipment.customPrice ?
                                <div className="form-group">
                                    <div className="col-sm-12 prices-box">
                                        <div className="col-sm-3">
                                            <div>
                                                <p>Price per day</p>
                                                <input type="text"
                                                       name="pricePerDay"
                                                       value={formatCurrencyValue(currentEquipment.pricePerDay ?? '') || ''}
                                                       onChange={this.handleChange}
                                                       maxLength={10} autoComplete="off"
                                                />
                                            </div>
                                        </div>
                                        {hasAdminAccess(this.props.account) ?
                                            <div className="col-sm-3">
                                                <div>
                                                    <p>Price per week</p>
                                                    <input type="text"
                                                           name="pricePerWeek"
                                                           value={formatCurrencyValue(currentEquipment.pricePerWeek ?? '') || ''}
                                                           onChange={this.handleChange}
                                                           maxLength={10} autoComplete="off"
                                                    />
                                                </div>
                                                <div className="calculated-field">
                                                    {currentEquipment.pricePerWeek ?
                                                        "($" + getPricePerDayFromWeeklyRate(currentEquipment.pricePerWeek) + " per day)" : ""}</div>

                                            </div>
                                            : null}
                                        <div className="col-sm-3">
                                            <div>
                                                <p>Price per month</p>
                                                <input type="text"
                                                       name="pricePerMonth"
                                                       value={formatCurrencyValue(currentEquipment.pricePerMonth ?? '') || ''}
                                                       onChange={this.handleChange}
                                                       maxLength={10} autoComplete="off"
                                                />
                                            </div>
                                            <div className="calculated-field">
                                                {currentEquipment.pricePerMonth ? "($" + getPricePerDayFromMonthlyRate(currentEquipment.pricePerMonth) + " per day)" : ""}</div>

                                        </div>
                                    </div>
                                </div>
                                :
                                <div className="form-group">
                                    <div className="col-sm-12 prices-box">
                                        <div className="col-sm-3">
                                            <div>
                                                <p>Price per day</p>
                                                <input type="text"
                                                       name="pricePerDay"
                                                       readOnly
                                                       disabled
                                                       value={this.props.location ? formatCurrencyValue(this.props.location.pricePerDay ?? '') : ''}
                                                />
                                            </div>
                                        </div>
                                        {hasAdminAccess(this.props.account) ?
                                            <div className="col-sm-3">
                                                <div>
                                                    <p>Price per week</p>
                                                    <input type="text"
                                                           name="pricePerWeek"
                                                           value={this.props.location ? formatCurrencyValue(this.props.location.pricePerWeek ?? '') : ''}
                                                           readOnly
                                                           disabled
                                                    />
                                                </div>
                                                <div className="calculated-field disabled">
                                                    {(this.props.location && this.props.location.pricePerWeek) ? "($" + getPricePerDayFromWeeklyRate(this.props.location.pricePerWeek) + " per day)" : ""}</div>

                                            </div>
                                            : null}
                                        <div className="col-sm-3">
                                            <div>
                                                <p>Price per month</p>
                                                <input type="text"
                                                       name="pricePerMonth"
                                                       value={this.props.location ? formatCurrencyValue(this.props.location.pricePerMonth ?? '') : ''}
                                                       readOnly
                                                       disabled
                                                />
                                            </div>
                                            <div className="calculated-field disabled">
                                                {(this.props.location && this.props.location.pricePerMonth) ? "($" + getPricePerDayFromMonthlyRate(this.props.location.pricePerMonth) + " per day)" : ""}</div>

                                        </div>
                                    </div>
                                </div>
                        }
                    </form>
                    : ''
                }
                    <Error>{this.state.errorMessage}</Error>
            </div>
        )
    }
}

export default LocationEquipment;
